const state = {
  localStore: false,
  address: null,
  balance: '0',
  blockNumber: 0,
  identifier: '',
  isHardware: false,
  ledgerBLE: false,
  ledgerApp: {},
  instance: null,
  isOfflineApp: false,
  web3: {},
  ensDomains: null,
  tokens: [],
  loadingWalletInfo: true,
  swapRates: []
};

export default state;
